// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rosterContainer {
    max-width: 1024px;
    margin: auto;
}

.rosters {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 50px;
}

.addCardContainer {
    width: 304px;
    height: 86px;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
}

.addCard {
    width: 258px;
    height: 76px;
    background-color: #1c1f25;
    border: 1px solid #000000;
    border-radius: 6px;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.addCard:hover {
    background-color: #242830;
}

.addCard img {
    width: 24px;
    height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/roster/Roster.style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".rosterContainer {\n    max-width: 1024px;\n    margin: auto;\n}\n\n.rosters {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 50px;\n}\n\n.addCardContainer {\n    width: 304px;\n    height: 86px;\n    display: flex;\n    justify-content: flex-end;\n    cursor: pointer;\n}\n\n.addCard {\n    width: 258px;\n    height: 76px;\n    background-color: #1c1f25;\n    border: 1px solid #000000;\n    border-radius: 6px;\n    margin-right: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.addCard:hover {\n    background-color: #242830;\n}\n\n.addCard img {\n    width: 24px;\n    height: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
